var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ai-models" }, [
    _c("div", { staticClass: "header" }, [
      _c("h3", { staticClass: "title" }, [_vm._v("AI Model Karşılaştırması")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "actions" },
        [
          _c(
            "div",
            { staticClass: "control" },
            [
              _c("label", [_vm._v("Modeli değiştir")]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticStyle: { width: "200px" },
                  attrs: { value: _vm.selectedModel },
                  on: { change: _vm.onChangeSelectedModel },
                },
                [
                  _c("a-select-option", { attrs: { value: "gpt-4o" } }, [
                    _vm._v("GPT‑4o"),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "gpt-4.1" } }, [
                    _vm._v("GPT‑4.1"),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "gpt-4.1-mini" } }, [
                    _vm._v("GPT‑4.1 Mini"),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "gpt-4.1-nano" } }, [
                    _vm._v("GPT‑4.1 Nano"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-button",
            {
              attrs: { type: "primary", loading: _vm.saving },
              on: { click: _vm.saveSelectedModel },
            },
            [_vm._v("Kaydet")]
          ),
          _vm._v(" "),
          _vm._m(0),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "cards",
        class: { "selection-active": !!_vm.selectedModel },
      },
      [
        _c(
          "div",
          {
            staticClass: "card highlight realtime model-gpt-4o",
            class: { "is-selected": _vm.selectedModel === "gpt-4o" },
            on: {
              click: function ($event) {
                return _vm.onSelect("gpt-4o")
              },
            },
          },
          [
            _vm.selectedModel === "gpt-4o"
              ? _c("div", { staticClass: "selected-ribbon" }, [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("check_circle"),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("Seçili")]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _vm._m(3),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "card highlight best model-gpt-41",
            class: { "is-selected": _vm.selectedModel === "gpt-4.1" },
            on: {
              click: function ($event) {
                return _vm.onSelect("gpt-4.1")
              },
            },
          },
          [
            _vm.selectedModel === "gpt-4.1"
              ? _c("div", { staticClass: "selected-ribbon" }, [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("check_circle"),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("Seçili")]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._m(4),
            _vm._v(" "),
            _vm._m(5),
            _vm._v(" "),
            _c("div", { staticClass: "desc" }, [
              _vm._v("Smartest non‑reasoning model"),
            ]),
            _vm._v(" "),
            _vm._m(6),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "card cheap model-gpt-41-mini",
            class: { "is-selected": _vm.selectedModel === "gpt-4.1-mini" },
            on: {
              click: function ($event) {
                return _vm.onSelect("gpt-4.1-mini")
              },
            },
          },
          [
            _vm.selectedModel === "gpt-4.1-mini"
              ? _c("div", { staticClass: "selected-ribbon" }, [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("check_circle"),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("Seçili")]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._m(7),
            _vm._v(" "),
            _vm._m(8),
            _vm._v(" "),
            _c("div", { staticClass: "desc" }, [
              _vm._v("Smaller, faster version of GPT‑4.1"),
            ]),
            _vm._v(" "),
            _vm._m(9),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "card nano model-gpt-41-nano",
            class: { "is-selected": _vm.selectedModel === "gpt-4.1-nano" },
            on: {
              click: function ($event) {
                return _vm.onSelect("gpt-4.1-nano")
              },
            },
          },
          [
            _vm.selectedModel === "gpt-4.1-nano"
              ? _c("div", { staticClass: "selected-ribbon" }, [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("check_circle"),
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v("Seçili")]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._m(10),
            _vm._v(" "),
            _vm._m(11),
            _vm._v(" "),
            _c("div", { staticClass: "desc" }, [
              _vm._v("Fastest, most cost‑efficient version of GPT‑4.1"),
            ]),
            _vm._v(" "),
            _vm._m(12),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "disclaimer" }, [
      _vm._v(
        "Fiyatlar göreceli olarak ifade edilmiştir; plan/bölge ve sürümlere göre değişir."
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "legend" }, [
      _c("span", { staticClass: "badge best" }, [_vm._v("Önerilen")]),
      _vm._v(" "),
      _c("span", { staticClass: "badge cheap" }, [_vm._v("Ekonomik")]),
      _vm._v(" "),
      _c("span", { staticClass: "badge realtime" }, [_vm._v("Gerçek Zamanlı")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-head" }, [
      _c("div", { staticClass: "name" }, [_vm._v("GPT‑4o")]),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c("span", { staticClass: "badge realtime" }, [
          _vm._v("Gerçek Zamanlı"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner" }, [
      _c("div", { staticClass: "banner-title" }, [_vm._v("GPT‑4o")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "details" }, [
      _c("div", { staticClass: "row" }, [
        _c("span", { staticClass: "title" }, [_vm._v("Intelligence")]),
        _c("span", { staticClass: "dots" }, [_vm._v("● ● ●")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("span", { staticClass: "title" }, [_vm._v("Speed")]),
        _c("span", { staticClass: "dots" }, [_vm._v("⚡⚡⚡⚡")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("span", { staticClass: "title" }, [_vm._v("Input")]),
        _c("span", { staticClass: "icons" }, [
          _c("span", { staticClass: "md-icon" }, [_vm._v("text_fields")]),
          _c("span", { staticClass: "md-icon" }, [_vm._v("image")]),
          _c("span", { staticClass: "md-icon disabled" }, [
            _vm._v("not_interested"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("span", { staticClass: "title" }, [_vm._v("Output")]),
        _c("span", { staticClass: "icons" }, [
          _c("span", { staticClass: "md-icon" }, [_vm._v("text_fields")]),
          _c("span", { staticClass: "md-icon" }, [_vm._v("image")]),
          _c("span", { staticClass: "md-icon disabled" }, [
            _vm._v("not_interested"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("span", { staticClass: "title" }, [_vm._v("Reasoning tokens")]),
        _c("span", { staticClass: "icons" }, [_vm._v("✖️")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pricing-block" }, [
        _c("div", { staticClass: "block-title" }, [
          _vm._v("PRICING "),
          _c("span", { staticClass: "muted" }, [_vm._v("PER 1M TOKENS")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "p-row" }, [
          _c("span", [_vm._v("Input")]),
          _c("span", [_vm._v("$2.50")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "p-row" }, [
          _c("span", [_vm._v("Cached Input")]),
          _c("span", [_vm._v("$1.25")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "p-row" }, [
          _c("span", [_vm._v("Output")]),
          _c("span", [_vm._v("$10.00")]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "context-block" }, [
        _c("div", { staticClass: "block-title" }, [_vm._v("CONTEXT")]),
        _vm._v(" "),
        _c("div", { staticClass: "p-row" }, [
          _c("span", [_vm._v("Window")]),
          _c("span", [_vm._v("128,000")]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-head" }, [
      _c("div", { staticClass: "name" }, [_vm._v("GPT‑4.1")]),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c("span", { staticClass: "badge best" }, [_vm._v("Önerilen")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner" }, [
      _c("div", { staticClass: "banner-title" }, [_vm._v("GPT‑4.1")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "details" }, [
      _c("div", { staticClass: "row" }, [
        _c("span", { staticClass: "title" }, [_vm._v("Intelligence")]),
        _c("span", { staticClass: "dots" }, [_vm._v("● ● ● ●")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("span", { staticClass: "title" }, [_vm._v("Speed")]),
        _c("span", { staticClass: "dots" }, [_vm._v("⚡⚡⚡")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("span", { staticClass: "title" }, [_vm._v("Input")]),
        _c("span", { staticClass: "icons" }, [
          _c("span", { staticClass: "md-icon" }, [_vm._v("text_fields")]),
          _c("span", { staticClass: "md-icon" }, [_vm._v("image")]),
          _c("span", { staticClass: "md-icon disabled" }, [
            _vm._v("not_interested"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("span", { staticClass: "title" }, [_vm._v("Output")]),
        _c("span", { staticClass: "icons" }, [
          _c("span", { staticClass: "md-icon" }, [_vm._v("text_fields")]),
          _c("span", { staticClass: "md-icon" }, [_vm._v("image")]),
          _c("span", { staticClass: "md-icon disabled" }, [
            _vm._v("not_interested"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("span", { staticClass: "title" }, [_vm._v("Reasoning tokens")]),
        _c("span", { staticClass: "icons" }, [_vm._v("✖️")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pricing-block" }, [
        _c("div", { staticClass: "block-title" }, [
          _vm._v("PRICING "),
          _c("span", { staticClass: "muted" }, [_vm._v("PER 1M TOKENS")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "p-row" }, [
          _c("span", [_vm._v("Input")]),
          _c("span", [_vm._v("$2.00")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "p-row" }, [
          _c("span", [_vm._v("Cached Input")]),
          _c("span", [_vm._v("$0.50")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "p-row" }, [
          _c("span", [_vm._v("Output")]),
          _c("span", [_vm._v("$8.00")]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "context-block" }, [
        _c("div", { staticClass: "block-title" }, [_vm._v("CONTEXT")]),
        _vm._v(" "),
        _c("div", { staticClass: "p-row" }, [
          _c("span", [_vm._v("Window")]),
          _c("span", [_vm._v("1,047,576")]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-head" }, [
      _c("div", { staticClass: "name" }, [_vm._v("GPT‑4.1 Mini")]),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c("span", { staticClass: "badge cheap" }, [_vm._v("Ekonomik")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner" }, [
      _c("div", { staticClass: "banner-title" }, [_vm._v("GPT‑4.1 mini")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "details" }, [
      _c("div", { staticClass: "row" }, [
        _c("span", { staticClass: "title" }, [_vm._v("Intelligence")]),
        _c("span", { staticClass: "dots" }, [_vm._v("● ● ●")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("span", { staticClass: "title" }, [_vm._v("Speed")]),
        _c("span", { staticClass: "dots" }, [_vm._v("⚡⚡⚡⚡⚡")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("span", { staticClass: "title" }, [_vm._v("Input")]),
        _c("span", { staticClass: "icons" }, [
          _c("span", { staticClass: "md-icon" }, [_vm._v("text_fields")]),
          _c("span", { staticClass: "md-icon" }, [_vm._v("image")]),
          _c("span", { staticClass: "md-icon disabled" }, [
            _vm._v("not_interested"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("span", { staticClass: "title" }, [_vm._v("Output")]),
        _c("span", { staticClass: "icons" }, [
          _c("span", { staticClass: "md-icon" }, [_vm._v("text_fields")]),
          _c("span", { staticClass: "md-icon" }, [_vm._v("image")]),
          _c("span", { staticClass: "md-icon disabled" }, [
            _vm._v("not_interested"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("span", { staticClass: "title" }, [_vm._v("Reasoning tokens")]),
        _c("span", { staticClass: "icons" }, [_vm._v("✖️")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pricing-block" }, [
        _c("div", { staticClass: "block-title" }, [
          _vm._v("PRICING "),
          _c("span", { staticClass: "muted" }, [_vm._v("PER 1M TOKENS")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "p-row" }, [
          _c("span", [_vm._v("Input")]),
          _c("span", [_vm._v("$0.40")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "p-row" }, [
          _c("span", [_vm._v("Cached Input")]),
          _c("span", [_vm._v("$0.10")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "p-row" }, [
          _c("span", [_vm._v("Output")]),
          _c("span", [_vm._v("$1.60")]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "context-block" }, [
        _c("div", { staticClass: "block-title" }, [_vm._v("CONTEXT")]),
        _vm._v(" "),
        _c("div", { staticClass: "p-row" }, [
          _c("span", [_vm._v("Window")]),
          _c("span", [_vm._v("1,047,576")]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-head" }, [
      _c("div", { staticClass: "name" }, [_vm._v("GPT‑4.1 Nano")]),
      _vm._v(" "),
      _c("div", { staticClass: "right" }, [
        _c("span", { staticClass: "badge nano" }, [_vm._v("Ultra Hafif")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner" }, [
      _c("div", { staticClass: "banner-title" }, [_vm._v("GPT‑4.1 nano")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "details" }, [
      _c("div", { staticClass: "row" }, [
        _c("span", { staticClass: "title" }, [_vm._v("Intelligence")]),
        _c("span", { staticClass: "dots" }, [_vm._v("● ●")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("span", { staticClass: "title" }, [_vm._v("Speed")]),
        _c("span", { staticClass: "dots" }, [_vm._v("⚡⚡⚡⚡⚡")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("span", { staticClass: "title" }, [_vm._v("Input")]),
        _c("span", { staticClass: "icons" }, [
          _c("span", { staticClass: "md-icon" }, [_vm._v("text_fields")]),
          _c("span", { staticClass: "md-icon" }, [_vm._v("image")]),
          _c("span", { staticClass: "md-icon disabled" }, [
            _vm._v("not_interested"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("span", { staticClass: "title" }, [_vm._v("Output")]),
        _c("span", { staticClass: "icons" }, [
          _c("span", { staticClass: "md-icon" }, [_vm._v("text_fields")]),
          _c("span", { staticClass: "md-icon" }, [_vm._v("image")]),
          _c("span", { staticClass: "md-icon disabled" }, [
            _vm._v("not_interested"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("span", { staticClass: "title" }, [_vm._v("Reasoning tokens")]),
        _c("span", { staticClass: "icons" }, [_vm._v("✖️")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pricing-block" }, [
        _c("div", { staticClass: "block-title" }, [
          _vm._v("PRICING "),
          _c("span", { staticClass: "muted" }, [_vm._v("PER 1M TOKENS")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "p-row" }, [
          _c("span", [_vm._v("Input")]),
          _c("span", [_vm._v("$0.10")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "p-row" }, [
          _c("span", [_vm._v("Cached Input")]),
          _c("span", [_vm._v("$0.03")]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "p-row" }, [
          _c("span", [_vm._v("Output")]),
          _c("span", [_vm._v("$0.40")]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "context-block" }, [
        _c("div", { staticClass: "block-title" }, [_vm._v("CONTEXT")]),
        _vm._v(" "),
        _c("div", { staticClass: "p-row" }, [
          _c("span", [_vm._v("Window")]),
          _c("span", [_vm._v("1,047,576")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }